import { render, staticRenderFns } from "./TableGroupItem.vue?vue&type=template&id=6db5e56b"
import script from "./TableGroupItem.vue?vue&type=script&lang=js"
export * from "./TableGroupItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6db5e56b')) {
      api.createRecord('6db5e56b', component.options)
    } else {
      api.reload('6db5e56b', component.options)
    }
    module.hot.accept("./TableGroupItem.vue?vue&type=template&id=6db5e56b", function () {
      api.rerender('6db5e56b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonPage/components/tableComp/tableItems/TableGroupItem.vue"
export default component.exports